import { Modal } from "artisn-ui-react";
import { useRouter } from "next/router";
import React from "react";

import { backdropConfig } from "./OutOfServiceModal.helpers";
import Styles from "./OutOfServiceModal.styles";
import { OutOfServiceModalProps as Props } from "./OutOfServiceModal.types";
import Button from "../Button/Button";
import useI18n from "hooks/useI18n";

import WifiSVG from "../../../../public/assets/images/alert-alt.svg";


const chkStr = (s?: string) => (s?.length ? s : undefined);

const OutOfServiceModal: React.FC<Props> = props => {
  const { outOfService } = props;
  const t = useI18n();
  const { locale } = useRouter();
  const isEnglish = locale === "en";
  const { title, titleEng } = outOfService ?? {};
  const { description, descriptionEng } = outOfService ?? {};
  const { url, urlTitle, urlTitleEng } = outOfService ?? {};
  const { whatsApp, whatsAppTitle, whatsAppTitleEng } = outOfService ?? {};
  const { whatsAppMessage, whatsAppMessageEng } = outOfService ?? {};

  const _title = isEnglish ? titleEng : title;
  const _description = isEnglish ? descriptionEng : description;
  const _urlTitle = isEnglish ? urlTitleEng : urlTitle;
  const _whatsAppTitle = isEnglish ? whatsAppTitleEng : whatsAppTitle;
  const _whatsAppMessage = isEnglish ? whatsAppMessageEng : whatsAppMessage;

  const handleWhatsAppClick = () => {
    const link = `https://wa.me/${whatsApp}?text=${_whatsAppMessage}`;
    window.open(link, "_blank");
  };

  const handleUrlClick = () => {
    window.open(url, "_blank");
  };

  return (
    <Modal
      backdropConfig={backdropConfig}
      className="OutOfServiceModal__modal"
      opened={true}
    >
      <Styles className="OutOfServiceModal">
        <div className="OutOfServiceModal__svg">
          <WifiSVG />
        </div>
        <h1 className="OutOfServiceModal__title">
          {chkStr(_title) ?? t.outOfService.title}
        </h1>
        <p className="OutOfServiceModal__description">
          {chkStr(_description) ?? t.outOfService.description}
        </p>
        <div className="OutOfServiceModal__buttons">
          {url ? (
            <Button
              className="OutOfServiceModal__button-secondary"
              onClick={handleUrlClick}
            >
              {chkStr(_urlTitle) ?? t.outOfService.visitWebsite}
            </Button>
          ) : null}
          {whatsApp ? (
            <Button
              className="OutOfServiceModal__button"
              onClick={handleWhatsAppClick}
            >
              {chkStr(_whatsAppTitle) ?? t.outOfService.contactWhatsapp}
            </Button>
          ) : null}
        </div>
      </Styles>
    </Modal>
  );
};

OutOfServiceModal.defaultProps = {};

export default OutOfServiceModal;
